import { FormStore, FormValidator } from '@estee/elc-form';
import {
  FIELD_TYPE,
  INVOICE_CARRIER_TYPES,
  INVOICE_DONATE_MARKS,
} from '../../../constants/Constants';
import { IInvoiceDetails } from '../../../api/IDataMappings';
import InvoiceDetails from '../InvoiceDetails';

interface ICorporateInvoiceData {
  [FIELD_TYPE.CORPORATE_NAME]: string;
  [FIELD_TYPE.CORPORATE_TAX_ID]: string;
}

export interface IInvoiceFormStoreAttributes extends Partial<IInvoiceDetails> {
  [FIELD_TYPE.INVOICE_CARRIER_ID]: string;
  [FIELD_TYPE.INVOICE_CARRIER_TYPE]: INVOICE_CARRIER_TYPES;
  [FIELD_TYPE.INVOICE_DONATE_MARK]: INVOICE_DONATE_MARKS;
  [FIELD_TYPE.INVOICE_DONATION_LOVE_CODE]: string;
}

class InvoiceFormStore extends FormStore<IInvoiceFormStoreAttributes> {
  constructor() {
    super({
      formValidator: new FormValidator(),
      initialValues: {
        [FIELD_TYPE.INVOICE_CARRIER_ID]: '',
        [FIELD_TYPE.INVOICE_CARRIER_TYPE]: INVOICE_CARRIER_TYPES.NONE,
        [FIELD_TYPE.INVOICE_DONATE_MARK]: INVOICE_DONATE_MARKS.NONE,
        [FIELD_TYPE.INVOICE_DONATION_LOVE_CODE]: '',
      },
    });
  }

  public buildInvoiceDetails(
    corporateInvoiceData: ICorporateInvoiceData,
  ): InvoiceDetails {
    const {
      [FIELD_TYPE.INVOICE_CARRIER_ID]: carrierId,
      [FIELD_TYPE.INVOICE_CARRIER_TYPE]: carrierType,
      [FIELD_TYPE.INVOICE_DONATE_MARK]: donateMark,
      [FIELD_TYPE.INVOICE_DONATION_LOVE_CODE]: donationLoveCode,
    } = this.values;

    const {
      [FIELD_TYPE.CORPORATE_NAME]: corporateName,
      [FIELD_TYPE.CORPORATE_TAX_ID]: corporateTaxId,
    } = corporateInvoiceData;
    let invoiceDetails: InvoiceDetails;

    switch (donateMark) {
      // Currently only corporate invoice could be paper invoice.
      case INVOICE_DONATE_MARKS.PAPER_INVOICE:
        invoiceDetails = InvoiceDetails.buildCorporateInvoiceDetails(
          corporateName,
          corporateTaxId,
        );
        break;
      case INVOICE_DONATE_MARKS.ELECTRONIC_INVOICE:
        invoiceDetails = InvoiceDetails.buildEInvoice(
          carrierType,
          carrierType === INVOICE_CARRIER_TYPES.EGUI ? carrierId : '',
        );
        break;
      case INVOICE_DONATE_MARKS.DONATION:
        invoiceDetails = InvoiceDetails.buildDonationInvoice(donationLoveCode);
        break;
      default:
        invoiceDetails = new InvoiceDetails();
        break;
    }

    return invoiceDetails;
  }

  public validate = (): boolean => {
    const {
      [FIELD_TYPE.INVOICE_CARRIER_TYPE]: carrierType,
      [FIELD_TYPE.INVOICE_DONATE_MARK]: donateMark,
      [FIELD_TYPE.INVOICE_DONATION_LOVE_CODE]: donationLoveCode,
    } = this.values;

    switch (donateMark) {
      case INVOICE_DONATE_MARKS.ELECTRONIC_INVOICE:
        return (
          carrierType === INVOICE_CARRIER_TYPES.MEMBERSHIP ||
          (carrierType === INVOICE_CARRIER_TYPES.EGUI &&
            !this.errors[FIELD_TYPE.INVOICE_CARRIER_ID])
        );
      case INVOICE_DONATE_MARKS.DONATION:
        return !!donationLoveCode;
      default:
        return false;
    }
  };
}

export default InvoiceFormStore;
